import { useState } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Paper,
  CircularProgress,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { getSubredditFromUrl } from '../utils/subreddit';
import {
  formatSubredditPlaceTitle,
  placeBrowsePath,
  placeLeaderboardPath,
} from '../utils/placePaths';

const TIMELAPSE_SRC = '/2026timelapse.gif';

export default function PlaceTimelapsePage() {
  const { subreddit: subParam } = useParams<{ subreddit?: string }>();
  const subreddit = (subParam || getSubredditFromUrl() || 'cfb').toLowerCase();
  const titleSub = formatSubredditPlaceTitle(subreddit);
  const [imgLoaded, setImgLoaded] = useState(false);

  const backPath = subreddit === 'cfb' && getSubredditFromUrl() ? '/' : `/${subreddit}`;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.100', pb: 4 }}>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar variant="dense" sx={{ flexWrap: 'wrap', gap: 0.5 }}>
          <IconButton edge="start" component={RouterLink} to={backPath} size="small" aria-label="Back">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 1, flex: 1, fontWeight: 600, minWidth: 0 }}>
            /r/{titleSub} Place — timelapse
          </Typography>
          <Button size="small" component={RouterLink} to={placeBrowsePath(subreddit)} sx={{ flexShrink: 0 }}>
            Browse
          </Button>
          <Button size="small" component={RouterLink} to={placeLeaderboardPath(subreddit)} sx={{ flexShrink: 0 }}>
            Leaderboard
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, pt: 2 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Full canvas evolution (may take a moment to load — large animation).
        </Typography>

        <Paper
          elevation={3}
          sx={{
            p: { xs: 1, sm: 2 },
            bgcolor: '#0d1117',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          {!imgLoaded && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress />
            </Box>
          )}
          <Box
            component="img"
            src={TIMELAPSE_SRC}
            alt={`/r/${titleSub} Place timelapse`}
            onLoad={() => setImgLoaded(true)}
            sx={{
              display: imgLoaded ? 'block' : 'none',
              width: '100%',
              height: 'auto',
              maxHeight: 'min(85vh, 1200px)',
              objectFit: 'contain',
              verticalAlign: 'middle',
            }}
          />
        </Paper>
      </Box>
    </Box>
  );
}
